import { createFileRoute } from '@tanstack/react-router';
import html from '#src/markdown/privacy.en.md';
import { MarkdownPage } from '#src/pages/MarkdownPage/index.ts';

export const Route = createFileRoute('/{-$locale}/privacy-policy')({
  component: RouteComponent,
  ssr: true
});

function RouteComponent() {
  return <MarkdownPage html={html} />;
}
